import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';

export class XsltApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getXslt(org_id: any): Promise<any> {
    return super.get(api.get_xslt + '?org_id=' + org_id);
  }
}
